import { WidgetDataSource } from '../../../../../../../models';
import {
  Widget,
  WidgetGroup,
  Comparison,
  SectionFilter,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class VolumePointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison,
    sectionFilter?: SectionFilter[]
  ): AiInsightPayloadParams {
    return super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison,
      sectionFilter
    );
  }
}
